<template>
	<div>
		<div class="x-stat">
			<a-row>
				<a-col :span="3">
					<a-statistic title="数量" :value="totalRow" />
				</a-col>
			</a-row>
		</div>

		<a-card :bordered="false">
			<div class="x-filter">
				<a-form layout="inline">
					<a-row :gutter="24">
						<a-col :span="4">
							<a-form-item label="用户">
								<a-input v-model="queryParams.user" placeholder="ID/昵称" />
							</a-form-item>
						</a-col>
						<a-col :span="4">
							<a-form-item label="性别">
								<a-select v-model="queryParams.sex" placeholder="请选择" default-value="">
									<a-select-option value="MALE">男</a-select-option>
									<a-select-option value="FEMALE">女</a-select-option>
								</a-select>
							</a-form-item>
						</a-col>

						<template v-if="advanced">
							<a-col :md="8">
								<a-form-item label="注册时间">
									<a-range-picker @change="onCreateTime" v-model="createTime" style="width:100%" />
								</a-form-item>
							</a-col>
						</template>

						<a-col :span="!advanced && 4 || 24">
							<span class="x-filter-submit-box"
								:style="advanced && {float:'right', overflow:'hidden'} || {}">
								<a-button type="primary" @click="fetchTableData">查询</a-button>
								<a-button style="margin-left:8px" @click="rest()">重置</a-button>
								<a @click="toggleAdvanced" style="margin-left: 8px">
									{{ advanced ? '收起' : '展开' }}
									<a-icon :type="advanced ? 'up' : 'down'" />
								</a>
							</span>
						</a-col>
					</a-row>
				</a-form>
			</div>

			<a-table :rowKey="record => record.id" :columns="tableColumns" :loading="tableLoading"
				:dataSource="tableData" :pagination="false">

				<template slot="user" slot-scope="record">
					<div class="user">
						<div class="user-left">
							<img class="cover-img" :src="record.avatarUrl" width="48px" height="48px" />
						</div>
						<div class="user-right">
							<p class="first">
								<span class="nickname">{{ record.nickname }}</span>
							</p>
							<p class="row">
								<span>{{ record.account }}</span>
							</p>
						</div>
					</div>
				</template>

				<template slot="content" slot-scope="record">
					<div class="content-box">
						<div class="text">
							{{ record.content }}
						</div>
						<div class="pic-list-box" v-if="record.type=='PHOTO' && record.picList">
							<x-image v-for="pic in record.picList" :src="pic.url" :key="pic.id" :width="80"
								:height="60"></x-image>
						</div>
						<div v-if="record.type=='VIDEO'">
							<a v-has="'/op/momentDetail'" @click="detail(record.id)">[点击查看视频]</a>
						</div>
					</div>
				</template>

				<template slot="action" slot-scope="record">
					<a v-has="'/content/momentDetail'" @click="detail(record.id)">详情</a>
					<a-divider type="vertical" />
					<a-dropdown>
						<a class="ant-dropdown-link" @click="e => e.preventDefault()">
							更多 <a-icon type="down" />
						</a>
						<a-menu slot="overlay">
							<a-menu-item><a v-has="'/content/momentAddLike'" @click="addLike(record.id)">点赞</a></a-menu-item>
							<a-menu-item><a v-has="'/content/momentAddComment'"
									@click="addComment(record.id)">评论</a></a-menu-item>
							<a-menu-item>
								<a-popconfirm placement="topRight" title="你确定要删除本条记录?" @confirm="momentDel(record.id)">
									<a v-has="'/content/momentDel'" href="#">删除</a>
								</a-popconfirm>
							</a-menu-item>
						</a-menu>
					</a-dropdown>
				</template>
			</a-table>

			<template>
				<a-modal v-model="likeVisible" :maskClosable="false" title="点赞" width="550px" @ok="likeHandleOk"
					@cancel="likeHandleCancel">
					<a-form-model ref="likeAdminForm" :model="likeForm" :label-col="{span:4}" :wrapper-col="{span:14}">
						<a-form-model-item label="用户" prop="userId"
							:rules="[{ required: true, message: '请选择用户', trigger: 'change' }, { validator: validateVestUserId, trigger: 'change' }]">
							<a-input v-show="false" v-model.number="likeForm.userId" type="hidden" />

							<div style="display: flex; align-items: center; gap: 8px;">
								<a-auto-complete v-model="searchValue" :data-source="vestDataSource"
									placeholder="搜索用户或点击随机选择" @search="onSearchVestUser" @change="onChangeVestUser"
									style="flex: 1;" />

								<a-button type="primary" @click="randomSelectUser()" :loading="randomLoading"
									icon="redo">
									换一个
								</a-button>
							</div>

						</a-form-model-item>
					</a-form-model>
				</a-modal>
			</template>

			<template>
				<a-modal v-model="commentVisible" :maskClosable="false" title="评论" width="550px" @ok="commentHandleOk"
					@cancel="commentHandleCancel">
					<a-form-model ref="commentAdminForm" :model="commentForm" :label-col="{span:4}" :wrapper-col="{span:14}">
						<a-form-model-item label="用户" prop="userId"
							:rules="[{ required: true, message: '请选择用户', trigger: 'change' }, { validator: validateVestUserId, trigger: 'change' }]">
							<a-input v-show="false" v-model.number="commentForm.userId" type="hidden" />

							<div style="display: flex; align-items: center; gap: 8px;">
								<a-auto-complete v-model="searchValue" :data-source="vestDataSource"
									placeholder="搜索用户或点击随机选择" @search="onSearchVestUser" @change="onChangeVestUser"
									style="flex: 1;" />

								<a-button type="primary" @click="randomSelectUser()" :loading="randomLoading"
									icon="redo">
									换一个
								</a-button>
							</div>
						</a-form-model-item>

						<a-form-model-item label="内容" prop="content"
							:rules="[{ required: true, message: '必填，不能为空', trigger: 'blur' }]">
							<a-textarea v-model="commentForm.content" :auto-size="{minRows:2, maxRows:5}" />
						</a-form-model-item>
					</a-form-model>
				</a-modal>
			</template>

			<template>
				<a-drawer :headerStyle="{fontSize:'18px', fontWeight:600}" placement="right" :closable="false"
					:visible="commentDetailVisible" width="500" :after-visible-change="afterVisibleChange"
					@close="onCommentDetailClose">
					<template slot="title">
						<div class="drawer-header">{{ title }}</div>
					</template>

					<!-- 动态内容展示区域 -->
					<div class="comment-detail">
						<div class="dynamic-content">
							<!-- 用户信息 -->
							<div class="user-info">
								<a-avatar :src="commentInfo.avatarUrl" size="large" />
								<div class="user-details">
									<div class="username">{{ commentInfo.nickname }}</div>
									<div class="time">{{ commentInfo.created }}</div>
								</div>
							</div>
						
							<!-- 文字内容 -->
							<div class="text-content" v-if="commentInfo.content">
								{{ commentInfo.content }}
							</div>
						
							<!-- 图片内容 -->
							<div class="image-content" v-if="commentInfo.type=='PHOTO'">
								<a-image-preview-group>
									<a-row :gutter="8">
										<a-col :span="8" v-for="(pic, index) in commentInfo.picList" :key="index"
											style="margin-bottom: 8px;">
											<x-image :src="pic.url" :key="index" :width="135" :height="110"></x-image>
										</a-col>
									</a-row>
								</a-image-preview-group>
							</div>
						
							<!-- 视频内容 -->
							<div class="video-content" v-if="commentInfo.type=='VIDEO'">
								<video :src="commentInfo.materialUrl" controls
									style="width: 100%; height: 300px; border-radius: 8px; background-color: black;"></video>
							</div>
						
							<!-- 互动数据 -->
							<div class="interaction-data">
								<span><a-icon type="like" /> {{ commentInfo.likeNum || 0 }}</span>
								<span><a-icon type="message" /> {{ commentInfo.commentNum || 0 }}</span>
								<span><a-icon type="share-alt" /> {{ commentInfo.relayNum || 0 }}</span>
							</div>
						
							<!-- 操作按钮 -->
							<!-- <div class="action-buttons">
								<a-button :type="currentItem.isLiked ? 'primary' : 'default'" @click="handleLike">
									<a-icon type="like" /> 点赞
								</a-button>
								<a-button @click="focusCommentInput">
									<a-icon type="message" /> 评论
								</a-button>
								<a-button @click="handleShare">
									<a-icon type="share-alt" /> 转发
								</a-button>
							</div> -->
						
							<!-- 评论输入框 -->
							<!-- <div class="comment-input" v-if="commentInputVisible">
								<a-textarea v-model="commentText" placeholder="写下你的评论..."
									:auto-size="{ minRows: 2, maxRows: 4 }" />
								<div style="margin-top: 10px; text-align: right;">
									<a-button @click="cancelComment">取消</a-button>
									<a-button type="primary" @click="submitComment" :disabled="!commentText.trim()">
										发布
									</a-button>
								</div>
							</div> -->
						
							<!-- 评论列表 -->
							<div class="comment-list" v-if="commentCommentList && commentCommentList.length">
								<div class="comment-title">评论列表</div>
								<!-- <div class="comment-item" v-for="comment in commentCommentList" :key="comment.id">
									<template v-if="comment.replyUserId > 0">
										<div class="comment-user">
											<a-avatar :src="comment.avatarUrl" size="small" />
											<span class="comment-username">{{ comment.nickname }}</span>
										</div>
										<div class="comment-content">回复：<span
												class="username">{{ comment.replyNickname }}</span> {{ comment.content }}
										</div>
										<div class="comment-time">{{ comment.created }}</div>
									</template>
									<template v-else>
										<div class="comment-user">
											<a-avatar :src="comment.avatarUrl" size="small" />
											<span class="comment-username">{{ comment.nickname }}</span>
										</div>
										<div class="comment-content">{{ comment.content }}</div>
										<div class="comment-time">{{ comment.created }}</div>
									</template>
								</div> -->
								
								<div class="comment-item" v-for="comment in commentCommentList" :key="comment.id">
									<div class="comment-user">
										<a-avatar :src="comment.avatar" size="small" />
										<span class="comment-username">{{ comment.nickname }}</span>
									</div>
									<div class="comment-content">{{ comment.content }}</div>
									<div class="comment-time">{{ comment.created }}</div>
									
									<div style="padding-left:20px">
										<div class="comment-item" v-for="repliesComment in comment.replies" :key="repliesComment.id">
											<div class="comment-user">
												<a-avatar :src="repliesComment.avatar" size="small" />
												<span class="comment-username">{{ repliesComment.nickname }}<a-icon type="caret-right" />{{ repliesComment.replyNickname }}</span>
											</div>
											<div class="comment-content">{{ repliesComment.content }}</div>
											<div class="comment-time">{{ repliesComment.created }}</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</a-drawer>
			</template>
			<div class="x-pagination">
				<a-pagination :pageSize="pageSize" v-model="pageIndex" :total="totalRow" @change="pageChange"
					:hideOnSinglePage="true" show-less-items />
			</div>
		</a-card>
	</div>
</template>

<script>
	import moment from "moment";
	import XImage from "@/components/XImage.vue";
	import {
		momentList,
		momentDel,
		momentAddLike,
		momentAddComment,
		momentDetail
	} from "@/api/content/moment.js";
	import {
		vestUserFind,
		userVestList
	} from "@/api/member/user";

	const tableColumns = [{
			title: '#',
			dataIndex: 'id'
		},
		{
			title: '用户',
			scopedSlots: {
				customRender: 'user'
			}
		},
		{
			title: '内容',
			scopedSlots: {
				customRender: 'content'
			}
		},
		{
			title: '点赞',
			dataIndex: 'likeNum'
		},
		{
			title: '评论',
			dataIndex: 'commentNum'
		},
		{
			title: '转发',
			dataIndex: 'relayNum'
		},
		{
			title: '创建时间',
			dataIndex: 'created'
		},
		{
			title: '操作',
			scopedSlots: {
				customRender: 'action'
			}
		}
	];

	export default {
		components: {
			XImage
		},
		data() {
			return {
				advanced: false,
				queryParams: {},
				totalRow: 0,
				tableColumns,
				tableData: [],
				tableLoading: false,
				pageSize: 20,
				pageIndex: 1,
				createTime: [],
				likeForm: { userId: 0 },
				momentId: 0,
				likeVisible: false,
				vestList: [],
				vestAllList: [],
				vestDataSource: [],
				searchValue: '',
				randomLoading: false,

				commentVisible: false,
				commentForm: { userId: 0, content: '' },
				type: '',
				commentDetailVisible: false,
				title: '',
				commentInfo: {},
				commentCommentList: {},
				commentInputVisible: false,
				commentText: ''
			}
		},
		created() {
			this.fetchTableData();
		},
		methods: {
			validateVestUserId(rule, value, callback) {
				if (value === undefined || value === null || value === '' || Number(value) <= 0) {
					callback(new Error('请选择用户'));
					return;
				}
				callback();
			},
			fetchTableData() {
				this.tableLoading = true;
				this.queryParams.pageSize = this.pageSize;
				this.queryParams.page = this.pageIndex;
				momentList(this.queryParams).then(res => {
					this.totalRow = res.data.totalRow;
					this.tableData = res.data.recordList;

					this.tableLoading = false;
				});
			},
			pageChange(current) {
				this.pageIndex = current;
				this.fetchTableData();
			},
			toggleAdvanced() {
				this.advanced = !this.advanced;
			},
			onCreateTime(values) {
				this.queryParams.startCreateTime = moment(values[0]).unix();
				this.queryParams.endCreateTime = moment(values[1]).unix();
			},
			rest() {
				this.createTime = [];
				this.queryParams = {}
			},
			addLike(momentId) {
				this.momentId = momentId;
				this.searchValue = "";
				this.type = 'like';
				this.likeVisible = true;

				if (this.vestAllList.length <= 0) {
					userVestList().then((res) => {
						this.vestAllList = res.data.vestUserList;
					});
				}
			},
			likeHandleOk() {
				this.$refs.likeAdminForm.validate((valid) => {
					if (!valid) {
						return;
					}
					const formData = {
						momentId: this.momentId,
						userId: this.likeForm.userId
					};
					momentAddLike(formData).then(() => {
						this.fetchTableData();
						this.$message.success('操作成功');
						this.likeVisible = false;
						this.resetLikeState();
					});
				});
			},
			likeHandleCancel() {
				this.resetLikeState();
				this.$nextTick(() => {
					if (this.$refs.likeAdminForm) {
						this.$refs.likeAdminForm.clearValidate();
					}
				});
			},
			resetLikeState() {
				this.searchValue = '';
				this.momentId = 0;
				this.type = '';
				this.likeForm = { userId: 0 };
			},
			onSearchVestUser(value) {
				vestUserFind(value).then(res => {
					this.vestDataSource = [];
					this.vestList = res.data.vestList;
					this.vestList.forEach((item) => {
						this.vestDataSource.push(item.nickname);
					});
				});
			},
			onChangeVestUser(value) {
				this.vestList.forEach((item) => {
					if (value == item.nickname) {
						if (this.type == 'like') {
							this.likeForm.userId = item.id;
						} else {
							this.commentForm.userId = item.id;
						}
					}
				});
			},
			// 随机选择用户
			async randomSelectUser() {
				this.randomLoading = true;

				try {
					// 随机选择一个用户
					const randomIndex = Math.floor(Math.random() * this.vestAllList.length);
					const selectedUser = this.vestAllList[randomIndex];

					// 更新表单字段
					this.searchValue = selectedUser.nickname;

					if (this.type == 'like') {
						this.likeForm.userId = selectedUser.id;
					} else {
						this.commentForm.userId = selectedUser.id;
					}

					// 更新数据源显示
					this.vestDataSource = [selectedUser.nickname];
				} catch (error) {
					this.$message.error('随机选择失败');
				} finally {
					this.randomLoading = false;
				}
			},

			addComment(momentId) {
				this.momentId = momentId;
				this.searchValue = "";
				this.type = 'comment'
				this.commentVisible = true;

				if (this.vestAllList.length <= 0) {
					userVestList().then((res) => {
						this.vestAllList = res.data.vestUserList;
					});
				}
			},
			commentHandleOk() {
				this.$refs.commentAdminForm.validate((valid) => {
					if (!valid) {
						return;
					}
					const val = { ...this.commentForm, momentId: this.momentId };
					momentAddComment(val).then(() => {
						this.fetchTableData();
						this.$message.success('操作成功');
						this.commentVisible = false;
						this.resetCommentState();
					});
				});
			},
			commentHandleCancel() {
				this.resetCommentState();
				this.$nextTick(() => {
					if (this.$refs.commentAdminForm) {
						this.$refs.commentAdminForm.clearValidate();
					}
				});
			},
			resetCommentState() {
				this.searchValue = '';
				this.momentId = 0;
				this.type = 'comment';
				this.commentForm = { userId: 0, content: '' };
			},
			momentDel(id) {
				momentDel(id).then(() => {
					this.fetchTableData();
				})
			},
			detail(id) {
				this.commentDetailVisible = true;
				this.title = '日常详情';

				momentDetail(id).then((res) => {
					this.commentInfo = res.data.commentInfo;
					this.commentCommentList = res.data.commentList;
				})
			},
			afterVisibleChange(val) {
				console.log('visible', val);
			},
			onCommentDetailClose() {
				this.commentDetailVisible = false;
			},

			/* handleLike() {
				this.currentItem.isLiked = !this.currentItem.isLiked;
				if (this.currentItem.isLiked) {
					this.currentItem.likeCount += 1;
				} else {
					this.currentItem.likeCount -= 1;
				}
				// 这里可以添加API调用
			},
			focusCommentInput() {
				this.commentInputVisible = true;
			},
			cancelComment() {
				this.commentInputVisible = false;
				this.commentText = '';
			},
			submitComment() {
				if (!this.commentText.trim()) return;

				const newComment = {
					id: Date.now(),
					userName: '当前用户',
					userAvatar: '',
					content: this.commentText,
					createTime: '刚刚'
				};

				this.currentItem.comments.unshift(newComment);
				this.currentItem.commentCount += 1;
				this.commentText = '';
				this.commentInputVisible = false;

				// 这里可以添加API调用
			},
			handleShare() {
				this.$info({
					title: '分享',
					content: '分享功能已触发'
				});
				this.currentItem.shareCount += 1;
				// 这里可以添加API调用
			} */
		}
	}
</script>

<style lang="less" scoped>
	.user {
		display: flex;
		flex-direction: row;
		align-items: center;

		.user-left {
			display: flex;
			flex-direction: column;
			margin-right: 5px;
			text-align: center;

			span {
				font-size: 12px;
			}
		}

		.user-right {
			p.first {
				display: flex;
				flex-direction: row;
				margin: 0;

				.nickname {
					color: #686868;
					font-weight: bold;
				}
			}

			p.row {
				font-size: 12px;
				color: #acacac;
				margin: 0;
			}
		}
	}

	.content-box {
		width: 256px;

		.pic-list-box {
			display: flex;
			flex-direction: row;
			display: grid;
			grid-template-columns: repeat(auto-fill, 80px);
			gap: 8px;

			.x-image {
				margin: 5px 5px 0 0;
			}
		}
	}

	.drawer-header {
		font-size: 18px;
		font-weight: 600;
		position: fixed;
		top: 0;
		right: 0;
		width: 500px;
		/* 与drawer宽度一致 */
		z-index: 100;
		background: white;
		border-bottom: 1px solid #f0f0f0;
		padding: 16px 24px;
		margin-bottom: 0;
	}

	::v-deep .ant-drawer-header {
		padding: 27px 24px;
	}

	::v-deep .ant-drawer-wrapper-body {
		overflow-y: hidden;
	}
	
	.comment-detail {
		height: 100%;
		display: flex;
		flex-direction: column;
		height: calc(100vh - 80px)
	}

	.dynamic-content {
		height: 100%;
		overflow-y: auto;
		/* 根据头部实际高度调整，避免内容被头部遮挡 */
		flex: 1;
		padding: 0px 16px 16px 16px;
		
		scrollbar-color: #1890ff #bae7ff;
		scrollbar-width: thin;
		-ms-overflow-style: none;
		position: relative;
	}

	.user-info {
		display: flex;
		align-items: center;
		margin-bottom: 16px;
	}

	.user-details {
		margin-left: 12px;
	}

	.username {
		font-weight: 500;
	}

	.time {
		font-size: 12px;
		color: #999;
	}

	.text-content {
		margin-bottom: 16px;
		line-height: 1.5;
	}

	.image-content {
		margin-bottom: 16px;
	}

	.video-content {
		margin-bottom: 16px;
	}

	.interaction-data {
		margin: 16px 0;
		color: #999;
	}

	.interaction-data span {
		margin-right: 16px;
	}

	.action-buttons {
		display: flex;
		margin-bottom: 16px;
	}

	.action-buttons button {
		margin-right: 8px;
	}

	.comment-input {
		margin-bottom: 16px;
	}

	.comment-title {
		font-weight: bold;
		margin-bottom: 12px;
	}

	.comment-item {
		padding: 12px 0;
		border-bottom: 1px solid #f0f0f0;
	}

	.comment-user {
		display: flex;
		align-items: center;
		margin-bottom: 6px;
	}

	.comment-username {
		margin-left: 8px;
		font-weight: 500;
	}

	.comment-content {
		margin-bottom: 6px;
		line-height: 1.4;
	}

	.comment-time {
		font-size: 12px;
		color: #999;
	}

	.username {
		color: #0066aa;
		font-size: 14px;
	}
</style>